// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as PickupDropForm from "./PickupDropForm.bs.js";
import * as Button$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as PlaceOrderFooter from "../shared/PlaceOrderFooter.bs.js";
import * as PlaceOrderMapCmp from "./PlaceOrderMapCmp.bs.js";
import * as PickupDropFormCmp from "./PickupDropFormCmp.bs.js";
import * as PlaceOrderContext from "../../context/PlaceOrderContext.bs.js";
import * as PlaceOrderGaConfig from "../../../app/helper/PlaceOrderGaConfig.bs.js";

function PlaceOrderFormCmp(Props) {
  var locationBounds = Props.locationBounds;
  var handleRestrictedVehicles = Props.handleRestrictedVehicles;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var defaultLatLng = {
    lat: 12.8715,
    lng: 77.5946
  };
  var match$1 = PlaceOrderContext.useContext(undefined).state;
  var wayPointThree = match$1.wayPointThree;
  var wayPointTwo = match$1.wayPointTwo;
  var wayPointOne = match$1.wayPointOne;
  var customerInfo = match$1.customerInfo;
  var dropAddress = match$1.dropAddress;
  var pickupAddress = match$1.pickupAddress;
  var wayPoints = [
    wayPointOne,
    wayPointTwo,
    wayPointThree
  ];
  var pickupLatLng = pickupAddress.latLng;
  var dropLatLng = dropAddress.latLng;
  var match$2 = PlaceOrderContext.useContext(undefined);
  var dispatch = match$2.dispatch;
  var enabledWayPoint = wayPoints.filter(function (e) {
        return e.showForm === true;
      });
  var getInitialAddress = function (address) {
    var match = address.senderNumber.length;
    return {
            addressLineOne: address.address1,
            addressLineTwo: address.address2,
            senderName: address.senderName,
            senderPhone: match !== 0 ? address.senderNumber : customerInfo.mobile
          };
  };
  var wayPointOneForm = PickupDropForm.Form.useForm(getInitialAddress(wayPointOne.address), {
        country: country,
        addressValidation: {
          locationBounds: locationBounds.drop_polygon,
          latLng: Belt_Option.getWithDefault(wayPointOne.address.latLng, defaultLatLng)
        }
      }, (function (param, param$1) {
          
        }));
  var wayPointTwoForm = PickupDropForm.Form.useForm(getInitialAddress(wayPointTwo.address), {
        country: country,
        addressValidation: {
          locationBounds: locationBounds.drop_polygon,
          latLng: Belt_Option.getWithDefault(wayPointTwo.address.latLng, defaultLatLng)
        }
      }, (function (param, param$1) {
          
        }));
  var wayPointThreeForm = PickupDropForm.Form.useForm(getInitialAddress(wayPointThree.address), {
        country: country,
        addressValidation: {
          locationBounds: locationBounds.drop_polygon,
          latLng: Belt_Option.getWithDefault(wayPointThree.address.latLng, defaultLatLng)
        }
      }, (function (param, param$1) {
          
        }));
  var pickUpForm = PickupDropForm.Form.useForm(getInitialAddress(pickupAddress), {
        country: country,
        addressValidation: {
          locationBounds: locationBounds.pickup_polygon,
          latLng: Belt_Option.getWithDefault(pickupLatLng, defaultLatLng)
        }
      }, (function (param, param$1) {
          
        }));
  var dropForm = PickupDropForm.Form.useForm(getInitialAddress(dropAddress), {
        country: country,
        addressValidation: {
          locationBounds: locationBounds.drop_polygon,
          latLng: Belt_Option.getWithDefault(dropLatLng, defaultLatLng)
        }
      }, (function (param, param$1) {
          console.log("Success Drop");
          
        }));
  var gaCaptureNameAndPhone = function (address, address_type) {
    return PlaceOrderGaConfig.publishEvent({
                category: /* PickUpDrop */1,
                action: address_type + " Name And Number",
                label: "1_" + address.senderName + "#2_" + address.senderNumber + "#3_" + customerInfo.mobile,
                value: undefined,
                nonInteraction: undefined
              }, country);
  };
  var pickupDropFormCmp = function (form, address_type, location_type, showCmp) {
    if (showCmp) {
      return React.createElement(PickupDropFormCmp.make, {
                  getSubmitDetails: (function (value, address1) {
                      PlaceOrderGaConfig.publishEvent({
                            category: /* PickUpDrop */1,
                            action: $$String.capitalize_ascii(address_type) + " Address",
                            label: "1_" + address1 + "#2_(" + value.lat.toString() + "," + value.lng.toString() + ")",
                            value: undefined,
                            nonInteraction: undefined
                          }, country);
                      return Curry._1(dispatch, {
                                  TAG: /* SetLatLng */1,
                                  _0: location_type,
                                  _1: value
                                });
                    }),
                  form: form,
                  address_type: address_type,
                  closeForm: (function (param) {
                      PlaceOrderGaConfig.publishEvent({
                            category: /* PickUpDrop */1,
                            action: "Delete Stop",
                            label: "1_" + customerInfo.mobile,
                            value: undefined,
                            nonInteraction: undefined
                          }, country);
                      switch (location_type) {
                        case /* PickUp */0 :
                        case /* Drop */1 :
                            break;
                        case /* WayPointOne */2 :
                            Curry._1(wayPointOneForm.reset, undefined);
                            break;
                        case /* WayPointTwo */3 :
                            Curry._1(wayPointTwoForm.reset, undefined);
                            break;
                        case /* WayPointThree */4 :
                            Curry._1(wayPointThreeForm.reset, undefined);
                            break;
                        
                      }
                      return Curry._1(dispatch, {
                                  TAG: /* RemoveWayPoint */7,
                                  _0: location_type
                                });
                    }),
                  showClose: location_type >= 2
                });
    } else {
      return null;
    }
  };
  return React.createElement(React.Fragment, undefined, React.createElement(PlaceOrderMapCmp.make, {
                  pickupLatLng: pickupLatLng,
                  dropLatLng: dropLatLng,
                  defaultLatLng: defaultLatLng,
                  wayPointOneLatLng: wayPointOne.address.latLng,
                  wayPointTwoLatLng: wayPointTwo.address.latLng,
                  wayPointThreeLatLng: wayPointThree.address.latLng
                }), React.createElement("div", {
                  className: "pickup-address"
                }, pickupDropFormCmp(pickUpForm, "pickup", /* PickUp */0, true), $$Array.mapi((function (i, e) {
                        var match = e.id;
                        switch (match) {
                          case /* None */0 :
                              return null;
                          case /* First */1 :
                              return pickupDropFormCmp(wayPointOneForm, "waypoint_" + String(i + 1 | 0), /* WayPointOne */2, wayPointOne.showForm);
                          case /* Second */2 :
                              return pickupDropFormCmp(wayPointTwoForm, "waypoint_" + String(i + 1 | 0), /* WayPointTwo */3, wayPointTwo.showForm);
                          case /* Third */3 :
                              return pickupDropFormCmp(wayPointThreeForm, "waypoint_" + String(i + 1 | 0), /* WayPointThree */4, wayPointThree.showForm);
                          
                        }
                      }), enabledWayPoint), pickupDropFormCmp(dropForm, "drop", /* Drop */1, true), React.createElement("div", {
                      className: "add-stop-button-container"
                    }, React.createElement(Button$Catalyst.make, {
                          text: "+ Add Stop",
                          cb: (function (_event) {
                              PlaceOrderGaConfig.publishEvent({
                                    category: /* PickUpDrop */1,
                                    action: "Add Stop",
                                    label: "1_" + customerInfo.mobile,
                                    value: undefined,
                                    nonInteraction: undefined
                                  }, country);
                              var array = [
                                wayPointOne,
                                wayPointTwo,
                                wayPointThree
                              ];
                              var disabledWayPoint = array.find(function (e) {
                                    return e.showForm === false;
                                  });
                              var id = disabledWayPoint !== undefined ? disabledWayPoint.id : /* None */0;
                              return Curry._1(dispatch, {
                                          TAG: /* AddNewWayPonit */5,
                                          _0: id
                                        });
                            }),
                          className: "btn-secondary disabled add-stop",
                          disabled: enabledWayPoint.length === 3
                        }))), React.createElement(PlaceOrderFooter.make, {
                  handleNextButton: (function (param) {
                      Curry._1(dispatch, {
                            TAG: /* SetAddress */9,
                            _0: /* PickUp */0,
                            _1: {
                              latLng: pickupAddress.latLng,
                              address1: pickUpForm.input.addressLineOne,
                              address2: pickUpForm.input.addressLineTwo,
                              senderName: pickUpForm.input.senderName,
                              senderNumber: pickUpForm.input.senderPhone
                            }
                          });
                      Curry._1(dispatch, {
                            TAG: /* SetAddress */9,
                            _0: /* Drop */1,
                            _1: {
                              latLng: dropAddress.latLng,
                              address1: dropForm.input.addressLineOne,
                              address2: dropForm.input.addressLineTwo,
                              senderName: dropForm.input.senderName,
                              senderNumber: dropForm.input.senderPhone
                            }
                          });
                      Curry._1(dropForm.submit, undefined);
                      Curry._1(pickUpForm.submit, undefined);
                      var enabledWaypointForms = $$Array.map((function (e) {
                              var match = e.id;
                              switch (match) {
                                case /* None */0 :
                                    return wayPointOneForm;
                                case /* First */1 :
                                    var init = wayPointOne.address;
                                    Curry._1(dispatch, {
                                          TAG: /* SetAddress */9,
                                          _0: /* WayPointOne */2,
                                          _1: {
                                            latLng: init.latLng,
                                            address1: wayPointOneForm.input.addressLineOne,
                                            address2: wayPointOneForm.input.addressLineTwo,
                                            senderName: wayPointOneForm.input.senderName,
                                            senderNumber: wayPointOneForm.input.senderPhone
                                          }
                                        });
                                    return wayPointOneForm;
                                case /* Second */2 :
                                    var init$1 = wayPointTwo.address;
                                    Curry._1(dispatch, {
                                          TAG: /* SetAddress */9,
                                          _0: /* WayPointTwo */3,
                                          _1: {
                                            latLng: init$1.latLng,
                                            address1: wayPointTwoForm.input.addressLineOne,
                                            address2: wayPointTwoForm.input.addressLineTwo,
                                            senderName: wayPointTwoForm.input.senderName,
                                            senderNumber: wayPointTwoForm.input.senderPhone
                                          }
                                        });
                                    return wayPointTwoForm;
                                case /* Third */3 :
                                    var init$2 = wayPointThree.address;
                                    Curry._1(dispatch, {
                                          TAG: /* SetAddress */9,
                                          _0: /* WayPointThree */4,
                                          _1: {
                                            latLng: init$2.latLng,
                                            address1: wayPointThreeForm.input.addressLineOne,
                                            address2: wayPointThreeForm.input.addressLineTwo,
                                            senderName: wayPointThreeForm.input.senderName,
                                            senderNumber: wayPointThreeForm.input.senderPhone
                                          }
                                        });
                                    return wayPointThreeForm;
                                
                              }
                            }), enabledWayPoint);
                      enabledWaypointForms.forEach(function (form) {
                            return Curry._1(form.submit, undefined);
                          });
                      var isWayPointFormValid = enabledWaypointForms.every(function (form) {
                            return Curry._1(form.valid, undefined);
                          });
                      var match = Curry._1(pickUpForm.valid, undefined);
                      var match$1 = Curry._1(dropForm.valid, undefined);
                      if (match && match$1 && isWayPointFormValid) {
                        var latLngList = Belt_List.toArray(Belt_List.keepMap({
                                  hd: dropAddress.latLng,
                                  tl: {
                                    hd: wayPointOne.address.latLng,
                                    tl: {
                                      hd: wayPointTwo.address.latLng,
                                      tl: {
                                        hd: wayPointThree.address.latLng,
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }, (function (x) {
                                    return x;
                                  })));
                        var pickup = pickupAddress.latLng;
                        if (pickup !== undefined) {
                          Curry._2(handleRestrictedVehicles, "PickUp", pickup);
                        }
                        latLngList.forEach(function (e) {
                              return Curry._2(handleRestrictedVehicles, "Drop", e);
                            });
                        gaCaptureNameAndPhone(pickupAddress, "Pickup");
                        enabledWayPoint.forEach(function (e, i) {
                              return gaCaptureNameAndPhone(e.address, "Waypoint_" + String(i + 1 | 0));
                            });
                        gaCaptureNameAndPhone(pickupAddress, "Drop");
                        PlaceOrderGaConfig.publishEvent({
                              category: /* PickUpDrop */1,
                              action: "Next Button Success",
                              label: "1_" + customerInfo.mobile,
                              value: undefined,
                              nonInteraction: undefined
                            }, country);
                        return Curry._1(dispatch, {
                                    TAG: /* ChangeCurrentStep */0,
                                    _0: /* VehicleSelectionStep */1
                                  });
                      }
                      return PlaceOrderGaConfig.publishEvent({
                                  category: /* PickUpDrop */1,
                                  action: "Next Button Failure",
                                  label: "1_" + customerInfo.mobile,
                                  value: undefined,
                                  nonInteraction: undefined
                                }, country);
                    }),
                  showBackButton: false
                }));
}

var make = PlaceOrderFormCmp;

export {
  make ,
  
}
/* react Not a pure module */
